<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-05-06 14:32:59
 * @Page: 用户数据看板
-->
<template>
    <div class="container">
        <Header :headerData="headerData"></Header>

        <div class="header">
            <div class="header-cardBox green">
                <div class="header-cardBox-left">
                    <span>{{ $t('home.totalSale')}}</span> 
                    <span class="num">{{ sale_total }}</span>
                </div>
                <img class="home_icon" src="@/assets/image/bike.png" alt="" width="60" height="40">
            </div>
            <div class="header-cardBox header-cardBox2 yellow">
                <div class="header-cardBox-left">
                    <span>{{ $t('home.lastWeekActivationNum') }}</span> 
                    <span class="num">{{ lastWeekActivationNum }}</span>
                </div>
                <img class="home_icon" src="@/assets/image/rocket.png" alt="" width="70" height="60">
            </div>
            <div class="header-cardBox header-cardBox3 red">
                <div class="header-cardBox-left">
                    <span>{{ $t('home.lastWeekSegmentCount') }}</span>   
                    <span class="num">{{ lastWeekSegmentCount }}</span>
                </div>
                <img class="home_icon" src="@/assets/image/compute.png" alt="" width="50" height="40">
            </div>
        </div>

        <div class="cityDist" id="cityDist">
            <div class="map_hd">
                <div class="title">{{ $t('home.cityDistribution') }}</div>
                
                <a-radio-group 
                    class="showType"
                    v-if="!isFullScreen" 
                    v-model:value="mode" 
                    button-style="solid" 
                    size="small"
                    :style="{ marginBottom: '8px' }"
                    @change="changeRadio" 
                >
                    <!-- <a-tooltip placement="topLeft">
                        <template #title>
                            <span>{{ $t('home.map') }}</span>
                        </template>
                        <a-radio-button value="map">
                            <component :is="$antIcons['GlobalOutlined']"  class="screenfull"></component>
                        </a-radio-button>
                    </a-tooltip>

                    <a-tooltip placement="topLeft">
                        <template #title>
                            <span>{{ $t('home.table') }}</span>
                        </template>
                        <a-radio-button value="table">
                            <component :is="$antIcons['AppstoreOutlined']"  class="screenfull"></component>
                        </a-radio-button>
                    </a-tooltip> -->

                    <!-- <a-tooltip placement="topLeft">
                        <template #title>
                            <span>{{ $t('home.expand') }}</span>
                        </template>
                        <a-radio-button v-if="!isFullScreen">
                            <component :is="$antIcons['ExpandOutlined']"  class="screenfull" @click="toggle"></component>
                        </a-radio-button>
                    </a-tooltip>

                    <a-tooltip placement="topLeft">
                        <template #title>
                            <span>{{ $t('home.compress') }}</span>
                        </template>
                        <a-radio-button v-if="isFullScreen">
                            <component :is="$antIcons['CompressOutlined']" class="screenfull" @click="toggle"></component>
                        </a-radio-button>
                    </a-tooltip> -->
                </a-radio-group>
            </div>
            

            <!--  用户分布列表 -->
            <Table
                v-if="mode == 'table'"
                class="table"
                :table="table"
            ></Table>
            <!--  用户分布地图 -->
            <div class="cardBox">
                <!-- <div id="chart" v-if="mode == 'map' && lang == 'zh'"></div>  lat: 49.4531, lng: 11.0776 -->
                <GoogleMap
                    v-if="mode == 'map'"
                    ref="myMapRef"
                    api-key="AIzaSyA5Dga-78RQTIgYkiALCnKQrpAvyWAFU6s"
                    style="width: 100%; height: 60vh;"
                    MapTypeId='terrain'
                    :center="defaultCenter"  
                    :zoom="6"
                    :mapTypeControl="false"
                    :streetViewControl="false"
                    :rotateControl="false"
                    language="en"
                    region="US"
                >
                    <Marker 
                        v-for="(item, index) in user_markers" 
                        :key="index" 
                        :options="{ 
                            position: {lat: item.latitude, lng:item.longitude}, 
                            anchorPoint: 'ENTER', 
                            icon:item.icon
                        }"
                        :clickable="true"
                        @click="clickMarket(item)"
                    />
                </GoogleMap>
            </div>
        </div>

        <!-- 数据图表 -->
        <div class="chart_block">
            <a-button type="primary" size="small" :loading="exportLoading" @click="downloadMaxTorque">
                <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.exportData') }}
            </a-button>
            <div id="torqueChart"></div>
        </div>
        
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import * as echarts from 'echarts'
    import 'echarts/extension/bmap/bmap';
    import screenfull from 'screenfull'
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { HomeApi } from '@/api/HomeApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate, exportFile } from '@/utils/global';
    import { GoogleMap, Marker, CustomMarker, InfoWindow } from 'vue3-google-map'
    

    const { t } = useI18n()

    const week = getWeek().week
    const currentDate = getWeek().currentDate
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const lang = ref(localStorage.getItem('lang') ? localStorage.getItem('lang') : '')
    const sale_total = ref(0)
    const mode = ref('map')
    const isFullScreen = ref(false)
    const mapRef = ref()
    const lastWeekActivationNum = ref(0) // 上周激活用户数
    const lastWeekSegmentCount = ref(0) // 上周活跃用户数
    const startDate = ref(new Date(`${getLastWeekDate(7)} 00:00:00`).getTime().toString().slice(0,10)) // 获取上一周周一对应的日期
    const endDate = ref(new Date(`${getLastWeekDate(1)} 23:59:59`).getTime().toString().slice(0,10)) // 获取上一周周日对应的日期
    const userIconx1 = ref('https://mt.googleapis.com/vt/icon/name=icons/onion/SHARED-mymaps-container-bg_4x.png,icons/onion/SHARED-mymaps-container_4x.png,icons/onion/1522-bicycle_4x.png&highlight=ff000000,FF5252&scale=0.7')
    const exportLoading = ref(false)

    const geoCoordMap = ref({})
    const filters = ref([])
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',  // 序号
                dataIndex: 'order_number',
                key: 'order_number',
                width:100,
            },
            {
                title: t('home.country'),  // 国家
                dataIndex: 'country',
                key: 'country',
                onFilter: (value, record) => record.country.indexOf(value) === 0,
            },
            {
                title: t('home.state'),  // 州
                dataIndex: 'subdivisions',
                key: 'subdivisions',
            }, 
            {
                title: t('home.city'), // 城市
                dataIndex: 'city',
                key: 'city',
            },
            {
                title: t('home.num'), // 激活用户数量
                dataIndex: 'num',
                key: 'num',
                sorter: (a, b) => a.num - b.num,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                // x: 1500,
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        }
    })

    const headerData = ref({
        menu:'menu.Home',
        menu_desc: 'menu.subHome',
        week: getWeek().week,
        current_time:getWeek().currentDate,
    })

    // 经纬度默认中心点
    const defaultCenter = ref({})
    const defaultCountry = ref({ 
        germany:{
            lat: 49.4531, lng: 11.0776 // 德国法兰克福
        },
        france:{
            lat: 45.7519444, lng: 4.8355556 // 法国里昂
        },
        norway:{
            lat: 59.9116667, lng: 10.7363889 // 挪威奥斯陆
        }
    })

    const user_markers = ref([
        // {
        //     latitude: 49.2552248,
        //     longitude: 8.5408115,
        //     icon:userIconx1.value
        // }
    ])
    // const data_value = [{ name: '海门', value: 9 }];  // 模拟数据
    // const geoCoordMap = {
    //         海门: [121.15, 31.89],
    //         鄂尔多斯: [109.781327, 39.608266],
    //         招远: [120.38, 37.35],
    //         舟山: [122.207216, 29.985295],
    //         齐齐哈尔: [123.97, 47.33],
    //         盐城: [120.13, 33.38],
    //         赤峰: [118.87, 42.28],
    // };

    // const convertData = function (data) {
    //     var res = [];
    //     for (var i = 0; i < data.length; i++) {
    //         var geoCoord = geoCoordMap[data[i].name];
    //         if (geoCoord) {
    //             res.push({
    //                 name: data[i].name,
    //                 value: geoCoord.concat(data[i].value)
    //             });
    //         }
    //     }
    //     console.log(res,'res1111')
    //     return res;
    // };

    const convertData = function () {
        var res = [];
        for(let key in geoCoordMap.value){
            if(geoCoordMap.value[key]){
                res.push({
                    name:key,
                    value:geoCoordMap.value[key]
                })
            }
        }
        return res;
    };

    const changeRadio = ()=>{
        if(mode.value == 'map') renderChart()
    }

    // 全屏切换
    const toggle =()=>{
        let cityDistEle = document.getElementById('cityDist')
        let chartEle = document.getElementById('chart')
        screenfull.toggle(cityDistEle)
        isFullScreen.value = !isFullScreen.value
        resetMapStyle(cityDistEle,chartEle)
    }

    const resetMapStyle = (cityDistEle,chartEle)=>{
        if(isFullScreen.value){
            cityDistEle.style.background = '#fff'
            cityDistEle.style.padding = '0 10px'
            chartEle.style.height = 'calc(100vh - 100px)'
        }else{
            cityDistEle.style.background = '#fff'
            cityDistEle.style.padding = '0'
            chartEle.style.height = '550px'
        }
    }

    // 监听是否全屏，解决通过esc按键退出全屏时，表格和地图的tab按钮不显示问题
    screenfull.on('change', () => {
        isFullScreen.value = screenfull.isFullscreen
        renderChart() // 重绘地图

        let cityDistEle = document.getElementById('cityDist')
        let chartEle = document.getElementById('chart')
        resetMapStyle(cityDistEle,chartEle)
    })

    // 图表
    const renderChart = ()=> {
        nextTick(() => {
            let myChart = echarts.init(document.getElementById('chart'))
            myChart.clear()

            window.addEventListener("resize", () => {
                myChart.resize();
            });
           
            let option = {
                title: {
                    left: 'center',
                    top:'10'
                },
                tooltip: {
                    trigger: 'item'
                },
                bmap: {
                    center: [29.0177803, 37.77426147],
                    zoom: 4,
                    roam: true,
                    mapStyle: {
                        styleJson: [
                            {
                                featureType: 'water',
                                elementType: 'all',
                                stylers: {
                                    color: '#d1d1d1'
                                }
                            },
                            {
                                featureType: 'land',
                                elementType: 'all',
                                stylers: {
                                    color: '#f3f3f3'
                                }
                            },
                            {
                                featureType: 'railway',
                                elementType: 'all',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'highway',
                                elementType: 'all',
                                stylers: {
                                    color: '#fdfdfd'
                                }
                            },
                            {
                                featureType: 'highway',
                                elementType: 'labels',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'arterial',
                                elementType: 'geometry',
                                stylers: {
                                    color: '#fefefe'
                                }
                            },
                            {
                                featureType: 'arterial',
                                elementType: 'geometry.fill',
                                stylers: {
                                    color: '#fefefe'
                                }
                            },
                            {
                                featureType: 'poi',
                                elementType: 'all',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'green',
                                elementType: 'all',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'subway',
                                elementType: 'all',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'manmade',
                                elementType: 'all',
                                stylers: {
                                    color: '#d1d1d1'
                                }
                            },
                            {
                                featureType: 'local',
                                elementType: 'all',
                                stylers: {
                                    color: '#d1d1d1'
                                }
                            },
                            {
                                featureType: 'arterial',
                                elementType: 'labels',
                                stylers: {
                                    visibility: 'off'
                                }
                            },
                            {
                                featureType: 'boundary',
                                elementType: 'all',
                                stylers: {
                                    color: '#fefefe'
                                }
                            },
                            {
                                featureType: 'building',
                                elementType: 'all',
                                stylers: {
                                    color: '#d1d1d1'
                                }
                            },
                            {
                                featureType: 'label',
                                elementType: 'labels.text.fill',
                                stylers: {
                                    color: '#999999'
                                }
                            }
                        ]
                    }
                },
                series: [
                    {
                        name: '城市',
                        type: 'scatter',
                        coordinateSystem: 'bmap',
                        data: convertData(),
                        symbolSize: function (val) {
                            // console.log(val,'kkmmm')
                            return val[2] * 10;
                        },
                        encode: {
                            value: 2
                        },
                        label: {
                            formatter: '{b}',
                            position: 'right',
                            show: false
                        },
                        emphasis: {
                            label: {
                                show: true
                            }
                        }
                    },
                ]
            };

            myChart.setOption(option);
      
        })
    }

    // 获取售车总数，上周激活用户数
    const getActivationRate = async ()=>{
        let res = await HomeApi.getInstance().getActivationRate()
        if(res.code === 0){
            sale_total.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取上周活跃用户数
    const getLastWeekActiveNum = async ()=>{
        let res = await HomeApi.getInstance().getLastWeekActiveNum(startDate.value, endDate.value) // 1685289600,1685894399
        if(res.code === 0){
            lastWeekActivationNum.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取上周活跃用户数
    const getSegmentCount = async ()=>{
        let res = await HomeApi.getInstance().getSegmentCount(startDate.value, endDate.value)
        if(res.code === 0){
            lastWeekSegmentCount.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取激活用户城市分布
    const getCityDistribution = async ()=>{
        let res = await HomeApi.getInstance().getCityDistribution()
        if(res.code === 0){
            let countryArr = []
            res.data.forEach((item,index)=>{
                item.order_number = index

                if(countryArr.length == 0){
                    countryArr.push(item.country)
                }else if(!countryArr.includes(item.country)){
                    countryArr.push(item.country)
                }
            })
            // console.log(countryArr,'countryArr')

            let filters = countryArr.map(item=>{
                return {
                    text: item,
                    value: item,
                }
            })

            table.value.columns.forEach(item=>{
                if(item.key == 'country'){
                    item.filters = filters
                }
            })

            table.value.data = []
            res.data.forEach(i=>{
                if(!!i.city){
                    table.value.data.push(i)
                }
            })
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取城市分布 
    // const getCityList = async ()=>{
    //     let res = await HomeApi.getInstance().getCityList()
    //     if(res.code === 0){
    //         let obj = {}
    //         res.data.forEach(item=>{
    //             if(!!item){
    //                 obj[item.city] = [item.longitude,item.latitude,1]
    //             }
    //         })
    //         geoCoordMap.value = obj
    //     }else{
    //         message.error(res.msg || res.message)
    //     }
    // }

    // 获取用户分布位置 
    const getUserLocation = async ()=>{
        let res = await HomeApi.getInstance().getCityList()
        if(res.code === 0){
            res.data.length > 0 && res.data.forEach(item=>{
                if(!!item){
                    user_markers.value.push({
                        latitude: item.latitude,
                        longitude: item.longitude,
                        icon:userIconx1.value
                    })
                }
            })
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 图表
    const renderTorqueChart = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('home.torqueChartTitle'),
                        textAlign: 'auto',
                        left: '3%',
                        nameTextStyle:{
                            fontSize: 10,
                        },
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        top:'15%',
                        bottom:'6%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        nameTextStyle:{
                            fontSize: 13,
                        },
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }

    // 获取最大扭矩
    const getMaxTorque = async ()=>{
        let param = [65,70,75,80,85,90,95,100,110,120]
        let res = await HomeApi.getInstance().getMaxTorque(param)
        if(res.code === 0){
            res.data = res.data.reverse()

            let xAxisData = [], seriesData = []
            res.data.length > 0 && res.data.forEach((per, index) => {
                xAxisData.push(per.range)
                seriesData.push(per.count)
            })

            renderTorqueChart(xAxisData, seriesData)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 下载最大扭矩图表数据
    const downloadMaxTorque = async ()=>{
        let param = [65,70,75,80,85,90,95,100,110,120]
        exportLoading.value = true
        let res = await HomeApi.getInstance().downloadMaxTorque(param)
        if (res.status == 200) {
            exportFile(res.data, `${t('home.maxTorqueData')}.csv`)
            message.success(t('base.downloadSucceeded'))
            exportLoading.value = false
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg})
            message.success(t('base.downloadFailed'))
            exportLoading.value = false
        }
    }

    onMounted(async ()=>{
        getActivationRate()
        getLastWeekActiveNum()
        getSegmentCount()
        getCityDistribution()
        getUserLocation()
        // renderTorqueChart()
        getMaxTorque()


        let tenant = userInfo.value.tenant_id
        defaultCenter.value = defaultCountry.value[tenant == 9? 'norway' : 'germany']
           
    })
</script>

<style lang="scss" scoped>

.container{
    .header{
        display: flex;

        .header-cardBox{
            display: flex;
            flex-direction: row;
            margin: 30px 30px 5px 0;
            padding: 10px 20px;
            width: 50%;
            font-size: 15px;
            color: #999;
            border-radius: 9px;
            
            .header-cardBox-left{
                display: flex;
                flex-direction: column;
                flex: 2;
                span{
                    display: block;
                    font-size: 18px;
                    font-weight: 500;
                }
                .num{
                    font-size: 30px;
                    color: #fff;
                    font-weight: bold;
                }   
            }
            .home_icon{
                display: flex;
                // flex: 1;
                align-items: center;
                margin-right: 25px;
                margin-top: 20px;
                font-size: 35px;
            }
            .header-cardBox-week{
                display: flex;
                flex-direction: column;
                span{
                    display: block;
                    font-size: 18px;
                }
                .num{
                    font-size: 30px;
                    color: #fff;
                    font-weight: bold;
                }   
            }
        }

        .header-cardBox2{
            .num{
                color: #000 !important;
            }
        }

        .header-cardBox3{
            border: 1px dashed #333;

            .num{
                color: #000 !important;
            }
        }

        .green{
            background: #576DFF;
            color:#fff
        }
        .yellow{
            background: #fff;
            color:#000
        }
        .red{
            background: #F7F6F9;
            color:#000
        }
    }

    .cityDist{
        margin-top: 30px;
        width:100%;

        .map_hd{
            display: flex;
            width:100%;

            .title{
                display: flex;
                flex: 1;
                justify-content: start;
                padding: 10px;
                font-size: 18px;
                font-weight: bold;
                text-align: center;
            }

            .showType{
                // display: flex;
                // flex: 1;
                margin-top: 13px;
                margin-right: 10px;
            }
        }

        .cardBox{
            margin: 0;
            padding: 10px;
            box-sizing: border-box;
            background: #eee;

            #chart{
                width: 100%;
                height: 350px;
            }

            ::v-deep .ant-card-body{
                padding: 10px;
            }
        }
    }

    .chart_block{
        margin: 45px 0 15px;

        #torqueChart{
            margin-top: 10px;
            padding: 10px;
            width: 50%;
            height: 350px;
            background: #fff;
            border-radius: 9px;
        }
        
    }

    ::v-deep .ant-table-thead > tr > th, 
    ::v-deep .ant-table-tbody > tr > td, 
    ::v-deep .ant-table tfoot > tr > th, 
    ::v-deep .ant-table tfoot > tr > td{
        padding: 12px 15px;
    }
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

</style>